<template>
  <div class="modal-payment">
    <div class="modal-content-sc">
      <img src="/images/sorry-icon.svg" />
      <h6>Payment Canceled!</h6>
      <p>Try Again.</p>
      <router-link :to="{ name: 'Home' }" class="subscription-btn"
        >Go Home</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Deny",
  data: () => {
    return {};
  },
  async created() {
    const phone = localStorage.getItem("phone")
      ? localStorage.getItem("phone")
      : "";
    if (phone === "") {
      return this.$router.push({ name: "Registration" });
    }
  },
  methods: {}
};
</script>

<style scoped>
.modal-payment {
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.7);
}

.modal-content-sc {
  max-width: 640px;
}

.modal-content-sc h6 {
  font-size: 24px;
  font-weight: 600;
  margin-top: 20px;
}

.modal-content-sc p {
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
}

.modal-content-sc .subscription-btn {
  border-width: 0;
  padding: 12px;
  border-radius: 3px;
  resize: none;
  border: none;
  color: #ffffff;
  display: block;
  font-size: 1rem;
  line-height: 1.5;
  background-image: -webkit-linear-gradient(-55deg, #377dff 30%, #a859b1 100%);
  font-family: inherit;
  font-weight: 500;
  margin-top: 30px;
  text-decoration: none;
}
</style>
